import ContentSection, {
  ContentSectionFlushContent,
  ContentSectionFooterButton,
  ContentSectionHeader,
  ContentSectionHeaderLink
} from '@/components/ContentSection';
import RankingsTable, { TeamRankingType } from '../RankingsTable';

export default function RankingsModule({
  href,
  teamRankings,
  title
}: {
  href: string;
  teamRankings: TeamRankingType[];
  title: string; // TODO auto infer title from genderSport/state ?
}) {
  return (
    <ContentSection>
      <ContentSectionHeader right={href && <ContentSectionHeaderLink href={href}>All Rankings</ContentSectionHeaderLink>}>
        {title}
      </ContentSectionHeader>
      <ContentSectionFlushContent>
        <RankingsTable teamRankings={teamRankings} />
      </ContentSectionFlushContent>
      {href && <ContentSectionFooterButton href={href}>Full Rankings</ContentSectionFooterButton>}
    </ContentSection>
  );
}
